import type ItemViewState from '../store/schema/ItemViewState';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

export default action('toggleItemHeader', function toggleItemHeader(viewState: ItemViewState) {
    return addDatapointConfig(
        // Count the number of times user toggle item header
        // CustomData: 1 - isHeaderExpanded to set
        {
            name: 'RPCountToggleItemHeader',
            customData: [!viewState.isHeaderExpanded],
        },
        { viewState }
    );
});
